"use strict";

const DisplayOptions = function () {
  var displayOptions = $(".display-options");
  var $mainDisplay = $("#main-legend.display-options");
  var $modalDisplay = $("#modal-legend.display-options");

  var loadLegendListeners = function () {
    displayOptions = displayOptions.length ? displayOptions : $(".display-options");
    $mainDisplay = $mainDisplay.length ? $mainDisplay : $("#main-legend.display-options");
    $modalDisplay = $modalDisplay.length ? $modalDisplay : $("#modal-legend.display-options");

    turnOffOldListeners();

    displayOptions.on("change", "input[type=checkbox]", function (e) {
      legendCheckboxChange(this);
    });

    displayOptions.on("click", "input[type=radio]", function (e) {
      legendRadioChange(this);
    });

    displayOptions.on("click", ".layer-label-button", function (e) {
      e.preventDefault();
      e.stopPropagation();
      layerLabelButtonClick(this);
    });

    displayOptions.on("click", ".basemap-dropdown-menu a", function () {
      basemapDropdownClick(this);
    });

    $mainDisplay.on("click", ".legend-button-close", function () {
      toggleLegendDisplay(false);
    });

    $mainDisplay.on("click", ".legend-button-legend", function () {
      toggleLegendDisplay(true);
    });

    $mainDisplay.on("click", ".legend-header-click", function () {
      toggleLegendArrow($(this));
    });

    $modalDisplay.on("click", ".legend-button-close", function () {
      toggleModalLegendDisplay(false);
    });

    $modalDisplay.on("click", ".legend-button-legend", function () {
      toggleModalLegendDisplay(true);
    });

    $modalDisplay.on("click", ".legend-header-click", function () {
      toggleLegendArrow($(this));
    });

    Tree.select("legendShowing").on("update", function () {
      var legendShowing = Tree.get("legendShowing");
      if (legendShowing) {
        showLegend();
      } else {
        hideLegend();
      }
    });

    Tree.select("modalLegendShowing").on("update", function () {
      var legendShowing = Tree.get("modalLegendShowing");
      if (legendShowing) {
        showModalLegend();
      } else {
        hideModalLegend();
      }
    });
  };

  var turnOffOldListeners = function () {
    displayOptions.off();
    $("#inventory-modal .legend-header-click").unbind("click");
    $("#mapContent .legend-header-click").unbind("click");
  };

  var basemapDropdownClick = function (that) {
    var mapId = $(that).closest(".floating-legend-group").data("mapId");

    BasemapFunctions.setBasemap($(that).data("style"), mapId);
  };

  var legendCheckboxChange = function (that) {
    var mapId = $(that).closest(".floating-legend-group").data("mapId");

    if (that.name === "cluster") {
      Clustering.setState($(that).data("layer"), that.checked);
    } else {
      Actions.toggleLayer(that.value, that.checked, mapId);
    }

    if (Tree.get("dataView") === "asset-management") {
      AssetManagementSummaryTableController.renderSummaryTable();
    }
  };

  var legendRadioChange = function (that) {
    if ($(that).hasClass("asset-radio-layer")) {
      AssetManagementRadioModeToggleController.handleRadioClick(that);
    }
    PostConstructionProjectGeoServerLayer.removeLayerOnRadioClick(that);
    if ($(that).attr("name") === "radio_condition_phase_toggle") {
      const constructionLayer = Tree.get(["layers", "constructionProjectG2", "isEnabled"])
        ? "constructionProjectG2"
        : "null";
      closeAnyOpenedPopups(constructionLayer);
      Tree.set(["filters", "conditionPhaseToggle"], that.value);
      return;
    }
    const mapId = $(that).closest(".floating-legend-group").data("mapId");
    const isEnabledPath = Actions.getLayerIsEnabledPathByMapId(mapId);
    const alreadyChecked = Tree.get(["layers", that.value, isEnabledPath]);
    const $container = $(that).closest(".layers-div");
    if (alreadyChecked) {
      closeAnyOpenedPopups($(that).attr("value"));
      handleLayerDisplay(that.value, false, mapId);
    } else {
      removeOtherRadioButtons($container, that.value, mapId);
      handleLayerDisplay(that.value, true, mapId);
    }
  };

  var layerLabelButtonClick = function (that) {
    var $button = $(that);
    const mapId = $(that).closest(".floating-legend-group").data("mapId");
    const clickedLegendLayerName = $button.closest("label").prev("input").val();
    const currentLegendLayerName = Tree.get([mapId, "currentLegendLayerName"]);
    const toggleLegendDisplayFunction =
      mapId === "modal" ? toggleModalLegendDisplay : toggleLegendDisplay;

    if (currentLegendLayerName) {
      if (currentLegendLayerName === clickedLegendLayerName) {
        Tree.set([mapId, "currentLegendLayerName"], null);
        toggleLegend(clickedLegendLayerName, false, mapId);
        toggleLegendDisplayFunction(false);
      } else {
        toggleLegend(currentLegendLayerName, false, mapId);
        Tree.set([mapId, "currentLegendLayerName"], clickedLegendLayerName);
        toggleLegend(clickedLegendLayerName, true, mapId);
        toggleLegendDisplayFunction(true);
      }
    } else {
      Tree.set([mapId, "currentLegendLayerName"], clickedLegendLayerName);
      toggleLegend(clickedLegendLayerName, true, mapId);
      toggleLegendDisplayFunction(true);
    }
  };

  var closeAnyOpenedPopups = function (radioLayerOption) {
    const listOfG2Layers = [
      "muniCatchBasin",
      "muniOutfalls",
      "muniBmp",
      "lidBmp",
      "muniManhole",
      "muniLiftStations",
      "muniCleanout",
      "muniOpenChannel",
      "muniPipes",
      "muniCulvert",
      "constructionProjectG2",
    ];
    const popupCloseButn = $(".leaflet-popup-close-button");
    if (radioLayerOption && popupCloseButn?.length && listOfG2Layers.includes(radioLayerOption)) {
      popupCloseButn[0].click();
    }
  };

  var removeOtherRadioButtons = function ($container, excludeValue, mapId) {
    const $otherRadios = $container.find(
      `[type="radio"]:not([value="${excludeValue}"], [name="radio_condition_phase_toggle"])`,
    );
    const layers = [];

    for (const radio of $otherRadios) {
      layers.push(radio.value);
    }

    removeRadioButtonLayers(mapId, layers);
  };

  var toggleLegendArrow = function (header) {
    //@TODO clean
    // thisDrain.find(".expand-arrow").removeClass("open");
    if (header.find(".expand-arrow").hasClass("open")) {
      if (!$("#inventory-modal").is(":visible")) {
        toggleLegendDisplay(false);
      } else {
        toggleModalLegendDisplay(false);
      }
      header.find(".expand-arrow").removeClass("open");
      header
        .closest(".map-layers")
        .find(".layers-body")
        .slideUp(400, function () {
          //don't change main map if toggling modal map
          if (!$("#inventory-modal").is(":visible")) {
            $("#mapContent .legend-button-legend").hide();
          } else {
            $("#inventory-modal .legend-button-legend").hide();
          }
        });
    } else {
      $(".legend-button-legend").show();
      $(".legend-button-close").hide();
      header.find(".expand-arrow").addClass("open");
      header.closest(".map-layers").find(".layers-body").slideDown(400);
    }
  };

  var handleLayerDisplay = function (layer, isEnabled, mapId) {
    const isGisDataView = DataViewFunctions.getCurrentDataViewProperty("isGisDataView");
    const hasAssociatedG2Layer =
      DataViewFunctions.getCurrentDataViewProperty("hasAssociatedG2Layer");

    Actions.toggleLayer(layer, isEnabled, mapId);
    toggleLegendLayerCheckbox(layer, isEnabled, mapId);

    var $displayOptions = mapId === "modal" ? $modalDisplay : $mainDisplay;
    $displayOptions = $displayOptions.find("input[value='" + layer + "']");
    $displayOptions.prop("checked", isEnabled);

    if ($displayOptions.length > 1) {
      console.warn("Multiple inputs with the same value in the same legend is not supported.");
    }

    if (Clustering.enabledForLayer(layer) && mapId !== "modal") {
      if (isGisDataView || hasAssociatedG2Layer) {
        Clustering.setSuperClusterEnabledCheckbox(layer, isEnabled);
      } else {
        Clustering.setEnabledCheckbox(layer, isEnabled);
      }
    }
  };

  var showLegend = function () {
    MapFunctions.setMapHeight();
    $("#mapContent .map-legend").show();
    $("#main-legend").toggleClass("open", true);
    $("#mapContent .legend-button-close").show();
    $("#mapContent .legend-button-legend").hide();
  };

  var showModalLegend = function () {
    $("#inventory-modal .map-legend").show();
    $("#inventory-modal .legend-button-close").show();
    $("#inventory-modal .legend-button-legend").hide();
  };

  var hideLegend = function () {
    $("#mapContent .map-legend").hide();
    $("#main-legend").toggleClass("open", false);
    $("#mapContent .legend-button-close").hide();
    $("#mapContent .legend-button-legend").show();
  };

  var hideModalLegend = function () {
    $("#inventory-modal .map-legend").hide();
    $("#inventory-modal .legend-button-close").hide();
    $("#inventory-modal .legend-button-legend").show();
  };

  var removeRadioButtonLayers = function (mapId, layerNames) {
    layerNames.forEach(function (layer) {
      handleLayerDisplay(layer, false, mapId);
    });
  };

  var unselectRadioButtons = function (mapId, ...radioGroups) {
    radioGroups.forEach(function (radioGroup) {
      var selector = mapId ? `.${radioGroup}-radio-layers-${mapId}` : `.${radioGroup}-radio-layers`;
      $(selector).find("input[type='radio']").prop("checked", false);
    });
  };

  var toggleLegend = function (layerName, isEnabled, mapId) {
    const $container = mapId === "modal" ? $("#modal-legend") : $("#main-legend");

    const layerConfig = LayerFunctions.getLayerConfig(layerName);
    if (layerConfig?.serviceUrl) {
      if (layerConfig?.mapLayerType === "map_server") {
        toggleCustomMapServerLayerLegend(layerConfig, isEnabled, mapId);
      } else {
        toggleCustomFeatureLayerLegend(layerConfig, isEnabled, mapId);
      }
      return null;
    }

    if (!layerConfig || !layerConfig.legendClass) {
      console.info(`No legend associated with layer ${layerName}.`);
      return null;
    }

    for (const legendClass of getLegendClasses(layerConfig)) {
      const $legendDiv = _getLegendDivByClass($container, legendClass);
      _toggleLegendLayer($legendDiv, layerName, layerConfig, isEnabled);
    }
  };

  var _toggleLegendLayer = function ($legendDiv, layerName, layerConfig, isEnabled) {
    isEnabled = updateLegendLayersEnabled($legendDiv, layerName, isEnabled).size !== 0;

    if (layerConfig.legendType === "invisible") {
      $legendDiv.toggleClass("invisible", !isEnabled);
    } else {
      $legendDiv.toggle(isEnabled);
    }
  };

  var toggleCustomMapServerLayerLegend = async function (customLayerSettings, isEnabled, mapId) {
    const $container = mapId === "modal" ? $("#modal-legend") : $("#main-legend");
    const $legendDiv = $container.find(".legend-custom-reference-layer");
    const parameters = {};

    if (isEnabled) {
      const token = await CustomLayerConfig.getCustomLayerTokenIfNeeded();
      if (token) {
        parameters.token = token;
      }

      const data = await Network.asPromise(
        $.ajax({
          type: "get",
          url: customLayerSettings.serviceUrl + "/legend?f=pjson",
          data: parameters,
          dataType: "json",
          headers: {
            // Authorization: "Basic " + btoa(username + ":" + password),
          },
        }),
      );

      $legendDiv.html(nunjucks.render("maps/legends/customReferenceLayerTableContent.njk", data));

      if (mapId === "modal") {
        MapFunctions.setLegendHeight("modal");
      }
    }

    $legendDiv.toggle(isEnabled);
  };

  var toggleCustomFeatureLayerLegend = async function (customLayerSettings, isEnabled, mapId) {
    const $container = mapId === "modal" ? $("#modal-legend") : $("#main-legend");
    const $legendDiv = $container.find(".legend-custom-reference-layer");

    if (isEnabled) {
      const metadata = await CustomLayerConfig.getCustomLayerMetadata(customLayerSettings);

      const legendItems = metadata.sublayers
        ? metadata.sublayers.flatMap((sublayer) => [
            { label: sublayer.name, labelOnly: true },
            ...getLegendItemsFromMetadata(sublayer.metadata, sublayer.name),
          ])
        : getLegendItemsFromMetadata(metadata, customLayerSettings.layerName);

      $legendDiv.html(
        nunjucks.render("maps/legends/customFeatureLayerTableContent.njk", { legendItems }),
      );

      if (mapId === "modal") {
        MapFunctions.setLegendHeight("modal");
      }
    }

    $legendDiv.toggle(isEnabled);
  };

  var getLegendItemsFromMetadata = function (metadata, simpleRendererLabel) {
    const geometryType = metadata.geometryType;
    const renderer = metadata.drawingInfo.renderer;

    if (renderer.type === "simple") {
      return [
        {
          label: simpleRendererLabel,
          style: getLegendStyle(renderer.symbol, geometryType),
        },
      ];
    } else if (renderer.type === "uniqueValue") {
      return renderer.uniqueValueInfos.map((info) => ({
        label: info.label || info.value,
        style: getLegendStyle(info.symbol, geometryType),
      }));
    } else if (renderer.type === "classBreaks") {
      return getClassBreaksLegendItems(renderer, geometryType);
    }

    return [];
  };

  var getClassBreaksLegendItems = function (renderer, geometryType) {
    const legendItems = [{ label: renderer.field, labelOnly: true }];

    const ranges = Layers.getClassBreaksRanges(renderer.classBreakInfos);
    for (let i = 0; i < ranges.length; i++) {
      const range = ranges[i];
      const label =
        renderer.classBreakInfos[i]?.label ||
        (range.min === -Infinity
          ? `≤ ${range.max}`
          : range.max === Infinity
            ? `> ${range.min}`
            : `${range.min} - ${range.max}`);
      legendItems.push({
        label: label,
        style: getLegendStyle(range.symbol, geometryType),
      });
    }

    if (renderer.defaultSymbol) {
      legendItems.push({
        label: renderer.defaultLabel || "Other",
        style: getLegendStyle(renderer.defaultSymbol, geometryType),
      });
    }

    return legendItems;
  };

  var getLegendStyle = function (symbol, geometryType) {
    if (geometryType === "esriGeometryPolygon") {
      return `background: ${symbol.color ? `rgba(${symbol.color[0]},${symbol.color[1]},${symbol.color[2]},${symbol.color[3] / 255})` : "#cbcbcb"};
              border: 2px solid ${symbol.outline?.color ? `rgba(${symbol.outline.color.join(",")})` : "#999"};
              width: 24px; height: 24px; display: inline-block; vertical-align: middle;`;
    }
    if (["esriGeometryLine", "esriGeometryPolyline"].includes(geometryType)) {
      return `border-bottom: 4px solid ${symbol.color ? `rgba(${symbol.color[0]},${symbol.color[1]},${symbol.color[2]},${symbol.color[3] / 255})` : "#999"};
              width: 32px; height: 0; display: inline-block; vertical-align: middle;`;
    }
    if (["esriGeometryPoint", "esriGeometryMultipoint"].includes(geometryType)) {
      if (symbol.imageData) {
        return `width: ${symbol.width}px; height: ${symbol.height}px; display: inline-block; vertical-align: middle;
                background: url(data:${symbol.contentType};base64,${symbol.imageData}) no-repeat center center; background-size: contain;`;
      } else if (symbol.url) {
        return `width: ${symbol.width}px; height: ${symbol.height}px; display: inline-block; vertical-align: middle;
                background: url(${symbol.url}) no-repeat center center; background-size: contain;`;
      }

      return `background: ${symbol.color ? `rgba(${symbol.color[0]},${symbol.color[1]},${symbol.color[2]},${symbol.color[3] / 255})` : "#cbcbcb"};
              border: 2px solid ${symbol.outline?.color ? `rgba(${symbol.outline.color.join(",")})` : "#999"};
              border-radius: 50%; width: 16px; height: 16px; display: inline-block; vertical-align: middle;`;
    }
    return "";
  };

  var updateLegendLayersEnabled = function ($legendDiv, layerName, isEnabled) {
    let layersEnabled = $legendDiv.data("layersEnabled");

    if (!layersEnabled) {
      layersEnabled = new Set();
      $legendDiv.data("layersEnabled", layersEnabled);
    }

    if (isEnabled) {
      layersEnabled.add(layerName);
    } else {
      layersEnabled.delete(layerName);
    }

    return layersEnabled;
  };

  var _getLegendDivByClass = function ($legendDiv, legendClass) {
    const conditionPhaseToggle = Tree.get(["filters", "conditionPhaseToggle"]) ?? "condition";

    if ($legendDiv.find(`.${legendClass}`).hasClass(conditionPhaseToggle)) {
      return $legendDiv.find(`.${legendClass}.${conditionPhaseToggle}`);
    } else {
      return $legendDiv.find(`.${legendClass}`);
    }
  };

  var toggleLegendLayerCheckbox = function (layerName, isEnabled, mapId) {
    var $legendDiv = mapId === "modal" ? $("#modal-legend") : $("#main-legend");

    const layerConfig = LayerFunctions.getLayerConfig(layerName);
    if (!layerConfig || !layerConfig.legendClass) {
      console.info(`No legend associated with layer ${layerName}.`);
      return null;
    }

    $legendDiv = $legendDiv.find(`[value="${layerName}"]`);
    $legendDiv.prop("checked", isEnabled);
  };

  var resetDisplayOptions = function () {
    toggleLegendDisplay(false);
    toggleModalLegendDisplay(false);
    displayOptions = $(".display-options");
    $mainDisplay = $("#main-legend.display-options");
    $modalDisplay = $("#modal-legend.display-options");
    loadLegendListeners();
  };

  var toggleLegendDisplay = function (display) {
    Tree.set("legendShowing", display);

    if (!display) {
      clearCurrentLegendLayerName();
    }
  };

  var toggleModalLegendDisplay = function (display) {
    Tree.set("modalLegendShowing", display);

    if (!display) {
      clearCurrentLegendLayerName("modal");
    }
  };

  var clearCurrentLegendLayerName = function (mapId = "main") {
    if (Tree.get([mapId, "currentLegendLayerName"])) {
      toggleLegend(Tree.get([mapId, "currentLegendLayerName"]), false, mapId);
      Tree.set([mapId, "currentLegendLayerName"], null);
    }
  };

  var handleLegendDisplayByConditionPhaseToggle = function (
    layerName,
    conditionPhaseToggle,
    areaLayerName = null,
  ) {
    if (Tree.get(["main", "currentLegendLayerName"]) !== layerName) {
      return;
    }

    toggleLegendByConditionPhaseToggle(layerName, conditionPhaseToggle);
    if (areaLayerName) {
      toggleLegendByConditionPhaseToggle(areaLayerName, conditionPhaseToggle);
    }
  };

  var toggleLegendByConditionPhaseToggle = function (layerName, conditionPhaseToggle) {
    var $legendDiv = $("#main-legend");

    if (Tree.get(["main", "currentLegendLayerName"]) === layerName) {
      const layerConfig = LayerFunctions.getLayerConfig(layerName);

      for (const legendClass of getLegendClasses(layerConfig)) {
        $legendDiv.find(`.${legendClass}.phase`).toggle(conditionPhaseToggle === "phase");
        $legendDiv.find(`.${legendClass}.condition`).toggle(conditionPhaseToggle === "condition");
      }
    }
  };

  var getLegendClasses = function (layerConfig) {
    const legendClass = layerConfig?.legendClass;

    if (!legendClass) {
      return [];
    }

    return Array.isArray(legendClass) ? legendClass : [legendClass];
  };

  var handleConditionPhaseToggleDisable = function (layerName, layerIsEnabled) {
    Misc.toggleDisabled(
      $(`input[name="radio_condition_phase_toggle"][data-layer="${layerName}"]`),
      !layerIsEnabled,
    );
  };

  var validateConditionPhaseToggleRadioButtons = function (conditionPhaseToggle) {
    $(`input[name="radio_condition_phase_toggle"][value="${conditionPhaseToggle}"]`).prop(
      "checked",
      true,
    );
  };

  return {
    loadLegendListeners,
    toggleLegend,
    removeRadioButtonLayers,
    handleLayerDisplay,
    unselectRadioButtons,
    resetDisplayOptions,
    removeOtherRadioButtons,
    legendRadioChange,
    handleLegendDisplayByConditionPhaseToggle,
    handleConditionPhaseToggleDisable,
    validateConditionPhaseToggleRadioButtons,
    _getLegendDivByClass,
    _toggleLegendLayer,
    layerLabelButtonClick,
  };
};

module.exports = DisplayOptions();

const Actions = require("../actions");
const BasemapFunctions = require("./basemapFunctions");
const Tree = require("../tree");
const Clustering = require("./clustering");
const LayerFunctions = require("../layerFunctions");
const MapFunctions = require("./mapFunctions");
const Misc = require("../misc");
const AssetManagementRadioModeToggleController = require("../assetManagement/assetManagementRadioModeToggleController");
const AssetManagementSummaryTableController = require("../assetManagement/assetManagementSummaryTableController");
const DataViewFunctions = require("../dataViewFunctions");
const PostConstructionProjectGeoServerLayer = require("../constructionG2/postConstructionProjectGeoServerLayer");
const Network = require("../network");
const CustomLayerConfig = require("../mapFunctions/customLayerConfig");
const Layers = require("./layers");
